// extracted by mini-css-extract-plugin
module.exports = {"alert":"Publish_alert__CQAjF","link":"Publish_link__xJkf6"};